export default import.meta.ROLLDOWN_FILE_URL_buPYRETakl2G4RmOlFtnQg